<div class="delivery-notes-pdf-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="text-purple-manax text-capitalize title-modal">
          Albarán {{document?.serieAndNumber}}
        </span>
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row">
    <div class="col-12">
      <ngx-extended-pdf-viewer
        [src]="src"
        [height]="'auto'"
        [filenameForDownload]="fileNameDownload"
      >
      </ngx-extended-pdf-viewer>
    </div>
  </div>
</div>